import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Footer from "./Footer";
import SecondFooter from "./SecondFooter";
import StickyFooter from "./StickyFooter";
import ThirdFooter from "./ThirdFooter";
import { FaWhatsapp, FaRegCalendarCheck } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import BasicFooter from "./BasicFooter";
import FirstDarkFooter from "./FirstDarkFooter";
import SecondDarkFooter from "./SecondDarkFooter";

function FooterWrapper() {
  const sitedata = useSelector((store) => store.global.loginData);
  const location = useLocation();
  const isDashboardRoute = location.pathname.startsWith("/patient");
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {sitedata?.theme_footer === "dark-style-1" ? (
        <FirstDarkFooter />
      ) : sitedata?.theme_footer === "dark-style-2" ? (
        <SecondDarkFooter />
      ) : sitedata?.theme_footer === "style-1-light" ? (
        <Footer />
      ) : sitedata?.theme_footer === "extended" ? (
        <div style={{
          marginBottom: width >= 992 ? "410px" : "0px",
        }}>
          <StickyFooter />
        </div>
      ) : sitedata?.theme_footer === "basic" ? (
        <BasicFooter />
      ) : sitedata?.theme_footer === "light-style" ? (
        <SecondFooter />
      ) : (
        <ThirdFooter />
      )}

      {!isDashboardRoute && (
        <div className="fixed-buttons">
          {sitedata?.permissions?.appointment === "show" && (
            <button className="appointment-button">
              <FaRegCalendarCheck
                style={{ marginRight: "10px", fontSize: "17px" }}
              />
              <Link to="/appointment" className="appointment-link">
                Appointment
              </Link>
            </button>
          )}

          {sitedata?.whatsapp_chat?.trim() && (
            <button
              className="whatsapp-button-wrapper"
              onClick={() =>
                window.open(`https://wa.me/${sitedata.whatsapp_chat}`, "_blank")
              }
            >
              <FaWhatsapp style={{ marginRight: "10px", fontSize: "17px" }} />
              {sitedata.whatsapp_chat}
            </button>
          )}
        </div>
      )}
    </>
  );
}

export default FooterWrapper;
